var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { createContext, Component } from 'react';
import PropTypes from 'prop-types';
import shallowEqual from 'shallowequal';
import defaultLocale from '../locale/default';
import { isObject } from '../_util/is';
import { lighten } from './util';
import Message from '../Message';
import Notification from '../Notification';
import { isServerRendering } from '../_util/dom';
import { setModalLocale } from '../Modal/locale';
export var ConfigContext = createContext({
    getPrefixCls: function (componentName) { return "byte-" + componentName; },
    locale: defaultLocale,
    getPopupContainer: function () { return document.body; },
    size: 'default',
});
var themeCache;
var colorList = [
    'primaryColor',
    'successColor',
    'infoColor',
    'warningColor',
    'dangerColor',
];
function setTheme(props) {
    var theme = props.theme;
    if (theme && isObject(theme)) {
        var root_1 = document.documentElement;
        Object.keys(theme).forEach(function (key) {
            root_1.style.setProperty("--" + key.replace(/([A-Z])/g, '-$1').toLowerCase(), theme[key]);
        });
        colorList.forEach(function (color) {
            if (theme[color]) {
                var colorString = color.replace(/([A-Z])/g, '-$1').toLowerCase();
                if (!theme[color + "Hover"]) {
                    root_1.style.setProperty("--" + colorString + "-hover", lighten(theme[color], 10));
                }
                if (color === 'primaryColor' && !theme[color + "Focus"]) {
                    root_1.style.setProperty("--" + colorString + "-focus", lighten(theme[color], 30));
                }
            }
        });
        themeCache = theme;
    }
}
var ConfigProvider = /** @class */ (function (_super) {
    __extends(ConfigProvider, _super);
    function ConfigProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.getPrefixCls = function (componentName) {
            var prefixCls = _this.props.prefixCls;
            return prefixCls + "-" + componentName;
        };
        _this.state = {};
        setTheme(props);
        setModalLocale(props.locale);
        return _this;
    }
    ConfigProvider.getDerivedStateFromProps = function (nextProps) {
        if (nextProps.theme && !shallowEqual(nextProps.theme, themeCache)) {
            setTheme(nextProps);
        }
        if (nextProps.prefixCls) {
            Message.config({ prefixCls: nextProps.prefixCls });
            Notification.config({ prefixCls: nextProps.prefixCls });
            if (!isServerRendering) {
                window.BYTEUI_PREFIXCLS = nextProps.prefixCls;
            }
        }
        return null;
    };
    ConfigProvider.prototype.componentDidUpdate = function (prevProps) {
        var locale = this.props.locale;
        if (prevProps.locale !== locale) {
            setModalLocale(locale);
        }
    };
    ConfigProvider.prototype.componentWillUnmount = function () {
        setModalLocale();
    };
    ConfigProvider.prototype.render = function () {
        var _a = this.props, children = _a.children, locale = _a.locale, getPopupContainer = _a.getPopupContainer, loadingElement = _a.loadingElement, size = _a.size;
        var config = {
            locale: locale,
            loadingElement: loadingElement,
            getPopupContainer: getPopupContainer,
            getPrefixCls: this.getPrefixCls,
            size: size,
        };
        return React.createElement(ConfigContext.Provider, { value: config }, children);
    };
    ConfigProvider.displayName = 'ConfigProvider';
    ConfigProvider.propTypes = {
        locale: PropTypes.object,
        theme: PropTypes.object,
        prefixCls: PropTypes.string,
        getPopupContainer: PropTypes.func,
        loadingElement: PropTypes.element,
    };
    ConfigProvider.defaultProps = {
        locale: defaultLocale,
        prefixCls: 'byte',
        getPopupContainer: function () { return document.body; },
        size: 'default',
    };
    return ConfigProvider;
}(Component));
export default ConfigProvider;
export var ConfigConsumer = ConfigContext.Consumer;
